export default {
  retrieveConfigs(data) {
    return this.post('/_exclusive/neo/configs', 'public', { data });
  },
  retrieveToggles(data) {
    return this.post('/_exclusive/neo/toggles', 'public', { data });
  },
};
